import {useReducer} from 'react'

const INITIAL_STATE = {
  alert: null,
  isSuccessNotificationVisible: false,
  isErrorNotificationVisible: false,
  isFiltersNotAppliedNotificationVisible: false,
  isDuplicatedAlertErrorNotificationVisible: false,
  isMaxLimitReachedAlertNotificationVisible: false,
  isMinimumFiltersAppliedNotificationVisible: false,
  notAvailableFilters: []
}

const ACTIONS = {
  SET_ALERT: 'SET_ALERT',
  SET_IS_SUCCESS_NOTIFICACION_VISIBLE: 'SET_IS_SUCCESS_NOTIFICACION_VISIBLE',
  SET_IS_ERROR_NOTIFICATION_VISIBLE: 'SET_IS_ERROR_NOTIFICATION_VISIBLE',
  SET_IS_FILTERS_NOT_APPLIED_NOTIFICATION_VISIBLE: 'SET_IS_FILTERS_NOT_APPLIED_NOTIFICATION_VISIBLE',
  SET_IS_DUPLICATED_ALERT_ERROR_NOTIFICATION_VISIBLE: 'SET_IS_DUPLICATED_ALERT_ERROR_NOTIFICATION_VISIBLE',
  SET_MAX_LIMIT_REACHED_ALERT_NOTIFICATION_VISIBLE: 'SET_MAX_LIMIT_REACHED_ALERT_NOTIFICATION_VISIBLE',
  SET_IS_ALERTS_TOOLTIP_VISIBLE: 'SET_IS_ALERTS_TOOLTIP_VISIBLE',
  SET_IS_MINIMUM_FILTERS_APPLIED_NOTIFICATION_VISIBLE: 'SET_IS_MINIMUN_FILTERS_APPLIED_NOTIFICATION_VISIBLE'
}

const getInitialState = ({isAlertsTooltipVisible}) => ({
  ...INITIAL_STATE,
  isAlertsTooltipVisible
})

const reducer = (state, action) => {
  const {type, payload} = action
  switch (type) {
    case ACTIONS.SET_ALERT:
    case ACTIONS.SET_IS_SUCCESS_NOTIFICACION_VISIBLE:
    case ACTIONS.SET_IS_ERROR_NOTIFICATION_VISIBLE:
    case ACTIONS.SET_IS_FILTERS_NOT_APPLIED_NOTIFICATION_VISIBLE:
    case ACTIONS.SET_IS_DUPLICATED_ALERT_ERROR_NOTIFICATION_VISIBLE:
    case ACTIONS.SET_MAX_LIMIT_REACHED_ALERT_NOTIFICATION_VISIBLE:
    case ACTIONS.SET_IS_ALERTS_TOOLTIP_VISIBLE:
    case ACTIONS.SET_IS_MINIMUM_FILTERS_APPLIED_NOTIFICATION_VISIBLE:
      return {
        ...state,
        ...payload
      }
    default:
      return state
  }
}

const useSearchSaveState = ({isAlertsTooltipVisible}) => {
  const [state, dispatch] = useReducer(reducer, getInitialState({isAlertsTooltipVisible}))

  const setAlert = alert => {
    dispatch({type: ACTIONS.SET_ALERT, payload: {alert}})
  }

  const showSuccessNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_SUCCESS_NOTIFICACION_VISIBLE,
      payload: {isSuccessNotificationVisible: true}
    })
  }

  const hideSuccessNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_SUCCESS_NOTIFICACION_VISIBLE,
      payload: {isSuccessNotificationVisible: false}
    })
  }

  const showErrorNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_ERROR_NOTIFICATION_VISIBLE,
      payload: {isErrorNotificationVisible: true}
    })
  }

  const hideErrorNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_ERROR_NOTIFICATION_VISIBLE,
      payload: {isErrorNotificationVisible: false}
    })
  }

  const showFiltersNotAppliedNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_FILTERS_NOT_APPLIED_NOTIFICATION_VISIBLE,
      payload: {isFiltersNotAppliedNotificationVisible: true}
    })
  }

  const hideFiltersNotAppliedNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_FILTERS_NOT_APPLIED_NOTIFICATION_VISIBLE,
      payload: {isFiltersNotAppliedNotificationVisible: false}
    })
  }

  const showDuplicatedAlertErrorNotification = ({notAvailableFilters}) => {
    dispatch({
      type: ACTIONS.SET_IS_DUPLICATED_ALERT_ERROR_NOTIFICATION_VISIBLE,
      payload: {isDuplicatedAlertErrorNotificationVisible: true, notAvailableFilters}
    })
  }

  const hideDuplicatedAlertErrorNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_DUPLICATED_ALERT_ERROR_NOTIFICATION_VISIBLE,
      payload: {isDuplicatedAlertErrorNotificationVisible: false}
    })
  }

  const showMaxLimitReachedAlertNotification = () => {
    dispatch({
      type: ACTIONS.SET_MAX_LIMIT_REACHED_ALERT_NOTIFICATION_VISIBLE,
      payload: {isMaxLimitReachedAlertNotificationVisible: true}
    })
  }

  const hideMaxLimitReachedAlertNotification = () => {
    dispatch({
      type: ACTIONS.SET_MAX_LIMIT_REACHED_ALERT_NOTIFICATION_VISIBLE,
      payload: {isMaxLimitReachedAlertNotificationVisible: false}
    })
  }

  const showMinimumFiltersAppliedNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_MINIMUM_FILTERS_APPLIED_NOTIFICATION_VISIBLE,
      payload: {isMinimumFiltersAppliedNotificationVisible: true}
    })
  }

  const hideMinimumFiltersAppliedNotification = () => {
    dispatch({
      type: ACTIONS.SET_IS_MINIMUM_FILTERS_APPLIED_NOTIFICATION_VISIBLE,
      payload: {isMinimumFiltersAppliedNotificationVisible: false}
    })
  }

  const showAlertsTooltip = () => {
    dispatch({
      type: ACTIONS.SET_IS_ALERTS_TOOLTIP_VISIBLE,
      payload: {isAlertsTooltipVisible: true}
    })
  }

  const hideAlertsTooltip = () => {
    dispatch({
      type: ACTIONS.SET_IS_ALERTS_TOOLTIP_VISIBLE,
      payload: {isAlertsTooltipVisible: false}
    })
  }

  return [
    state,
    {
      setAlert,
      showSuccessNotification,
      hideSuccessNotification,
      showErrorNotification,
      hideErrorNotification,
      showFiltersNotAppliedNotification,
      hideFiltersNotAppliedNotification,
      showDuplicatedAlertErrorNotification,
      hideDuplicatedAlertErrorNotification,
      showMaxLimitReachedAlertNotification,
      hideMaxLimitReachedAlertNotification,
      showMinimumFiltersAppliedNotification,
      hideMinimumFiltersAppliedNotification,
      showAlertsTooltip,
      hideAlertsTooltip
    }
  ]
}

export default useSearchSaveState
